/**
 * Add to favourites. Reflect committed server state, including failed requests.
 */
export function addToFavourites(element) {
    element.off('click.growtypeFavourites').on('click.growtypeFavourites', function (event) {
        event.preventDefault();
        event.stopPropagation();

        const btn = $(this);
        if (btn.data('favouritePending')) return;

        btn.data('favouritePending', true).attr('aria-busy', 'true');

        const showFailure = (response) => {
            const message = response && response.data && response.data.message;
            if (message === 'profile_required') {
                $('#growtypeFormAuthModal').modal('show');
            } else if (message === 'subscription_required') {
                $('#growtypeWcSubscriptionModal').modal('show');
            } else {
                alert('Unable to update favourites. Please try again.');
            }
        };

        const applyCommittedState = (response) => {
            if (!response || !response.success || !response.data ||
                !['added', 'removed'].includes(response.data.action)) {
                showFailure(response);
                return;
            }

            const added = response.data.action === 'added';
            btn.toggleClass('is-active', added);
            if (!added && $('body').hasClass('page-id-2293')) {
                btn.closest('.growtype-post-single').fadeOut();
            }

            if (typeof growtypeAnalyticsCapture === 'function') {
                growtypeAnalyticsCapture('favourite_changed', {
                    action: response.data.action,
                    character_id: response.data.character_id,
                    character_slug: response.data.character_slug,
                });
            }

            if (response.data.label) {
                btn.find('span').text(response.data.label);
            } else {
                btn.find('span').text(added ? 'Following' : 'Follow');
            }

            if (response.data.total_likes !== undefined) {
                btn.closest('.g-chatprofile').find('.g-chatprofile-stats .g-chatprofile-stats-single[data-key="total_likes"]').attr('data-value', response.data.total_likes);
                btn.closest('.g-chatprofile').find('.g-chatprofile-stats .g-chatprofile-stats-single[data-key="total_likes"] .g-chatprofile-stats-single-value').text(response.data.total_likes);
            }
        };

        const finish = () => btn.removeData('favouritePending').removeAttr('aria-busy');
        const client = typeof window !== 'undefined' ? window.talkiemateApiV2Client : null;
        const resource = String(btn.attr('data-resource') || 'characters');
        const slug = String(btn.attr('data-slug') || '');
        if (client && typeof client.setFavourite === 'function') {
            const desired = !btn.hasClass('is-active');
            client.setFavourite(resource, slug, desired)
                .then((payload) => applyCommittedState({
                    success: true,
                    data: {
                        action: payload.data.favourite ? 'added' : 'removed',
                        character_slug: payload.data.slug,
                    },
                }))
                .catch(() => showFailure(null))
                .finally(finish);
            return;
        }

        jQuery.ajax({
            url: growtype_child_ajax.url,
            type: 'post',
            data: {
                action: 'assistant_addtofavourites',
                assistant_slug: btn.attr('data-slug'),
                nonce: growtype_child_ajax.nonce
            },
            success: function (response) {
                applyCommittedState(response);
            },
            error: function (response) {
                showFailure(response && response.responseJSON);
            },
            complete: function () {
                finish();
            }
        });
    });
}
